export const roundPercent = (percent: number) => {
	if (percent >= 1) {
		return Math.round(percent);
	}
	if (percent >= 0.1) {
		return Math.round(percent * 10) / 10;
	}
	return Math.round(percent * 100) / 100;
};
